import { render, staticRenderFns } from "./ByTypeOfKnowledge.vue?vue&type=template&id=6d2c4748&"
import script from "./ByTypeOfKnowledge.vue?vue&type=script&lang=js&"
export * from "./ByTypeOfKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports